<div class="account-settings-language-wrapper">
  <div
    *ngFor="let language of languages"
    class="account-settings-language-item"
    (click)="onLanguagePreferenceSelection(language)"
  >
    <span class="ods-typography-body-m-bold">{{ language.friendlyName }}</span>
    <mat-icon *ngIf="selectedLanguageCode === language.languageCode">check</mat-icon>
  </div>
</div>
